<div class="text-xs space-y-2">
  <p class="mb-2 font-bold">{{ 'outlook.summary.task.title' | translate }}</p>

  @if (loading) {
    <maximizer-outlook-skeleton
      containerClasses="h-[120px] w-full rounded bg-neutral-25"
    ></maximizer-outlook-skeleton>
  }

  @if (!loading && !configuration.overdue && !configuration.upcoming) {
    <p class="text-body pb-8">
      {{ 'outlook.summary.task.emptyState' | translate }}
    </p>
  }

  @if (!loading && configuration.overdue) {
    <div
      class="bg-white min-h-[120px] max-h-[150px] w-100 rounded border border-neutral-20 flex flex-col p-2 pl-2 mb-2 justify-around"
    >
      <div class="flex">
        <div class="flex-shrink-0">
          <span
            class="mr-1 my-auto fa-icons icon-solid icon-12 icon-circle-check text-neutral-70"
          ></span>
        </div>
        <div class="flex-1 flex flex-col">
          <span class="font-bold my-auto line-clamp-2 mb-2 smart-word-break">{{
            configuration.overdue.description
          }}</span>

          <div class="flex items-center">
            <span class="text-neutral-90 mr-1"
              >{{ 'outlook.summary.task.dueDate' | translate }}:</span
            >
            <span class="text-error">{{
              configuration.overdue.dueDate
                | date: outlookStore.fullDateTimeFormat()
            }}</span>
            <span
              class="ml-1 fa-icons icon-solid icon-12 icon-clock text-error"
            ></span>
          </div>

          <div class="flex">
            <span class="text-neutral-90 mr-1"
              >{{ 'outlook.summary.task.priority' | translate }}:</span
            >
            <span
              class="text-ellipsis overflow-hidden whitespace-nowrap text-neutral-70"
              >{{ configuration.overdue.priority }}</span
            >
          </div>

          <div class="flex text-neutral-90 text-body">
            {{ 'outlook.summary.task.assignedTo' | translate }}:
          </div>

          <div class="flex">
            @if (configuration.overdue.assignedTo) {
              <span class="my-auto avatar avatar-xxs bg-inserv-10">{{
                configuration.overdue.assignedTo.DisplayValue | nameInitials
              }}</span>
            }
            <div class="flex flex-col">
              <span class="my-auto ml-2 line-clamp-1 text-neutral-70">{{
                configuration.overdue.assignedTo.DisplayValue
              }}</span>
            </div>
          </div>

          <div class="flex">
            <span class="ml-auto caption text-neutral-70">{{
              configuration.overdue.creationDate
                | date: outlookStore.fullDateTimeFormat()
            }}</span>
          </div>
        </div>
      </div>
    </div>

    <div class="mb-2 flex items-center gap-2">
      <span class="text-neutral-70">
        {{ configuration.overdueTaskAmount }}
        {{ 'outlook.summary.task.overdueAmount' | translate }}
      </span>
      <a
        id="outlook-task-ui-summaryTask-overdue"
        class="underline text-link"
        [href]="deepLink"
        target="_blank"
        rel="noopener"
        >{{ 'outlook.summary.openInMaximizer' | translate }}</a
      >
    </div>
  }

  @if (!loading && configuration.upcoming) {
    <div
      class="bg-white min-h-[120px] max-h-[150px] w-100 rounded border border-neutral-20 flex flex-col p-2 pl-2 mb-2 justify-around"
    >
      <div class="flex">
        <div class="flex-shrink-0">
          <span
            class="mr-1 my-auto fa-icons icon-solid icon-12 icon-circle-check text-neutral-70"
          ></span>
        </div>
        <div class="flex-1 flex flex-col">
          <span class="font-bold my-auto line-clamp-2 mb-2 smart-word-break">
            {{ configuration.upcoming.description }}
          </span>

          <div class="flex">
            <span class="text-neutral-90 mr-1"
              >{{ 'outlook.summary.task.dueDate' | translate }}:</span
            >
            <span class="text-neutral-70">{{
              configuration.upcoming.dueDate
                | date: outlookStore.fullDateTimeFormat()
            }}</span>
          </div>

          <div class="flex">
            <span class="text-neutral-90 mr-1"
              >{{ 'outlook.summary.task.priority' | translate }}:</span
            >
            <span class="text-neutral-70">{{
              configuration.upcoming.priority
            }}</span>
          </div>

          <div class="flex text-neutral-90 text-body">
            {{ 'outlook.summary.task.assignedTo' | translate }}:
          </div>

          <div class="flex">
            @if (configuration.upcoming.assignedTo) {
              <span class="my-auto avatar avatar-xxs bg-inserv-10">{{
                configuration.upcoming.assignedTo.DisplayValue | nameInitials
              }}</span>
            }
            <div class="flex flex-col">
              <span class="my-auto ml-2 line-clamp-1 text-neutral-70">{{
                configuration.upcoming.assignedTo.DisplayValue
              }}</span>
            </div>
          </div>

          <div class="flex">
            <span class="ml-auto caption text-neutral-70">{{
              configuration.upcoming.creationDate
                | date: outlookStore.fullDateTimeFormat()
            }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="mb-2 flex items-center gap-2">
      <span class="text-neutral-70">
        {{ configuration.upcomingTaskAmount }}
        {{ 'outlook.summary.task.upcomingAmount' | translate }}
      </span>
      <a
        id="outlook-task-ui-summaryTask-upcoming"
        class="underline text-link"
        [href]="deepLink"
        target="_blank"
        rel="noopener"
        >{{ 'outlook.summary.openInMaximizer' | translate }}</a
      >
    </div>
  }
</div>
